import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

// Fallback static data in case API returns empty results
const fallbackCategories = [
  {
    title: 'PROTEIN',
    image: '/assets/images/new-images/Yeast Protein Cafe Mocha Monocarton.png',
    searchQuery: 'protein'
  },
  {
    title: 'COLLAGEN',
    image: '/assets/images/new-images/Jar-1.png',
    searchQuery: 'collagen'
  },
];

const Shop_By_Category = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState(fallbackCategories);
  const [loading, setLoading] = useState(false);

  // Function to fetch product data from API
  const fetchCategoryData = async (query) => {
    try {
      const response = await fetch(`https://evercorenutrition.com/ev_admin/api/products/search/?q=${query}`);
      const data = await response.json();
      return data.results || [];
    } catch (error) {
      console.error(`Error fetching ${query}:`, error);
      return [];
    }
  };

  // Load data for both categories on component mount
  useEffect(() => {
    const loadCategories = async () => {
      setLoading(true);
      
      const proteinResults = await fetchCategoryData('protein');
      const collagenResults = await fetchCategoryData('collagen');
      
      // Update categories with real data if available, otherwise keep fallback
      const updatedCategories = [
        {
          title: 'PROTEIN',
          image: proteinResults.length > 0 && proteinResults[0]?.main_image 
            ? (proteinResults[0].main_image.startsWith('http') ? proteinResults[0].main_image : `https://evercorenutrition.com${proteinResults[0].main_image}`)
            : fallbackCategories[0].image,
          searchQuery: 'protein',
          productCount: proteinResults.length,
          products: proteinResults
        },
        {
          title: 'COLLAGEN',
          image: collagenResults.length > 0 && collagenResults[0]?.main_image 
            ? (collagenResults[0].main_image.startsWith('http') ? collagenResults[0].main_image : `https://evercorenutrition.com${collagenResults[0].main_image}`)
            : fallbackCategories[1].image,
          searchQuery: 'collagen',
          productCount: collagenResults.length,
          products: collagenResults
        }
      ];
      
      setCategories(updatedCategories);
      setLoading(false);
    };
    
    loadCategories();
  }, []);

  // Handle category click - navigate to shop with search filter
  const handleCategoryClick = (category) => {
    if (category.products && category.products.length > 0) {
      navigate(`/product/${category.products[0].id}`);
    } else {
      navigate(`/shop?category=${category.searchQuery}`);
    }
  };

  return (
    <>
      <section>
        <div className="container-fluid-lg">
          <div className="title mt-3" style={{ 
  textAlign: 'center', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center',
  width: '100%' 
}}>
            <h2>Shop By categories</h2>
            <span className="title-leaf">
              <svg className="icon-width">
                <use href="../assets/svg/leaf.svg#leaf"></use>
              </svg>
            </span>
          </div>

          {/* Main wrapper - row layout on desktop, column on mobile */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '1.5rem',
            alignItems: 'stretch'
          }} className="shop-category-wrapper">
            
            {/* Left: Shop By Category Grid */}
            <div style={{
              flex: '2',
              minWidth: '280px'
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                gap: '1.5rem',
                height: '100%'
              }}>
                {categories.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => handleCategoryClick(item)}
                    style={{
                      cursor: 'pointer',
                      background: '#f9f6ef',
                      borderRadius: '24px',
                      overflow: 'hidden',
                      transition: 'transform 0.25s ease, box-shadow 0.2s',
                      boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-6px)';
                      e.currentTarget.style.boxShadow = '0 16px 28px rgba(0,0,0,0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.05)';
                    }}
                  >
                    {/* Image with fixed aspect ratio for mobile */}
                    <div style={{
                      position: 'relative',
                      width: '100%',
                      paddingTop: '100%', // Creates 1:1 aspect ratio
                      overflow: 'hidden',
                      backgroundColor: '#f0ede8'
                    }}>
                      <img
                        src={item.image}
                        alt={item.title}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          display: 'block'
                        }}
                        onError={(e) => {
                          e.target.src = fallbackCategories.find(cat => cat.title === item.title)?.image || '/assets/images/placeholder.png';
                        }}
                      />
                    </div>
                    
                    {/* Overlay / Title Section */}
                    <div style={{
                      padding: '1rem',
                      textAlign: 'center',
                      background: '#2c3e2f'
                    }}>
                      <span style={{
                        color: 'white',
                        fontSize: '1rem',
                        fontWeight: '600',
                        letterSpacing: '1px',
                        textTransform: 'uppercase'
                      }}>
                        {item.title}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Right: Banner Image - HIDDEN ON MOBILE */}
            <div style={{
              flex: '1.2',
              minWidth: '260px'
            }} className="banner-container">
              <div style={{
                height: '100%',
                minHeight: '300px',
                borderRadius: '24px',
                overflow: 'hidden',
                boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
                backgroundColor: '#e8e4dc'
              }}>
                <img
                  src="/assets/images/sbcbanner.webp"
                  alt="Category Banner"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block'
                  }}
                  onError={(e) => {
                    e.target.src = '/assets/images/new-images/Yeast Protein Pouch combo -1.png';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Responsive styles - hides banner on mobile */}
      <style>{`
        @media (max-width: 768px) {
          .shop-category-wrapper {
            flex-direction: column !important;
          }
          
          .shop-category-wrapper > div:first-child {
            width: 100%;
          }
          
          /* HIDE THE BANNER (third image) ON MOBILE */
          .banner-container {
            display: none !important;
          }
        }
        
        /* Desktop stays horizontal and shows banner */
        @media (min-width: 769px) {
          .shop-category-wrapper {
            flex-direction: row !important;
          }
          
          .banner-container {
            display: block !important;
          }
        }
        
        .title h2 {
          font-size: 1.8rem;
          font-weight: 700;
          color: #2c3e2f;
          text-transform: uppercase;
        }
        
        @media (max-width: 480px) {
          .title h2 {
            font-size: 1.4rem;
          }
        }
      `}</style>
    </>
  );
};

export default Shop_By_Category;